<template>
  <div v-if="showCatalog" class="ml-3 m-0 list-group list-group-flush">
    <div class="list-group-item list-group-item-secondary font-weight-bold position-relative">
      <div class="position-absolute" style="left:15px;top:10px;">
        <i v-if="allPrescribed" class="fas fa-check-square mr-3" @click="setAllPrescribed(false)"></i>
        <i v-else class="far fa-square mr-3" @click="setAllPrescribed(true)"></i>
      </div>

      <div style="margin-left:20px;" @click="show = !show">
        {{catalog.name}}

        <div class="position-absolute" style="right:5px;top:12px;">
          <i :class="'fas mr-3 fa-chevron-' + (show ? 'up' : 'down')"></i>
        </div>
      </div>
    </div>

    <div v-if="show">
      <Item
          v-for="item in data"
          :key="item.id"
          :item="item"
          :updatePrescription="updatePrescription" />

      <CheckupCatalog
          v-for="innerCatalog in catalog.inner"
          :key="innerCatalog.id"
          :catalog="innerCatalog"
          :items="items"
          :updatePrescription="updatePrescription" />
    </div>
  </div>
</template>

<script>
  import Item from './Item';

  export default {
    name: 'CheckupCatalog',

    components: {Item},

    props: ['catalog', 'items', 'updatePrescription'],

    data() {
      return {
        show: true,
      };
    },

    computed: {
      data() {
        return this.items.filter(item => item.catalog === this.catalog.id);
      },

      showCatalog() {
        return this.catalog.inner.length > 0 || this.data.length > 0;
      },

      allPrescribed() {
        for (const item of this.data) {
          if (!item.isPrescribed) {
            return false;
          }
        }

        return true;
      }
    },

    methods: {
      async setAllPrescribed(state) {
        const promises = [];

        for (const item of this.data) {
          promises.push(this.updatePrescription(item.id, state));
        }

        await Promise.all(promises);
      },
    },
  };
</script>
